import { Chip } from '@mui/material';
import { useState } from 'react';
import { Tag } from '@wwf/sdk';
import { TagEditModal } from './TagEditModal';

type TagChipProps = {
    tag: Tag;
    onUnlink?: () => Promise<void>;
};

export function TagChip({ tag, onUnlink }: TagChipProps) {
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleClick = () => {
        setOpen(true);
    };

    return (
        <>
            <Chip
                size="small"
                variant="filled"
                onDelete={onUnlink}
                label={tag.name}
                onClick={handleClick}
                sx={{
                    '&.MuiChip-colorDefault': {
                        color: 'black',
                        backgroundColor: tag.color || undefined,
                        border: 0,
                    },
                    '& .MuiChip-deleteIcon': {
                        color: 'darkgrey',
                    },
                }}
            />
            <TagEditModal tag={tag} open={open} onClose={handleClose} />
        </>
    );
}
